enum AreaSearchMode {
  CURRENT_MAP_VIEW_CENTER = "currentMapViewCenter",
  CURRENT_USER_LOCATION = "currentUserLocation",
  ENTITY = "entity",
  ADDRESS = "address",
}

export default AreaSearchMode;
